// Scene key 具名常數
// Phaser Scene 以字串 key 註冊與切換（this.scene.start(key)）；本檔提供 const 配對，
// 避免 'Boot'/'Home'/'Game'/'Result' 字面值散落各 scene 檔，改 key 時一處同步。

export const SceneKey = {
  Boot: 'Boot',
  Home: 'Home',
  TableSelect: 'TableSelect',
  GameSetup: 'GameSetup',
  Dice: 'Dice', // 每局擲骰開局過場（圈風×局，home／續局 → dice → game）
  Game: 'Game',
  // 牌局結束三畫面（依序：各家狀態 → 算台數 → 籌碼結算）
  ResultTile: 'ResultTile', // 各家狀態（攤牌）
  ResultPoint: 'ResultPoint', // 算台數
  ResultMoney: 'ResultMoney', // 籌碼結算
  SessionSummary: 'SessionSummary',
  Shop: 'Shop', // 商店（購買與請人幫忙付）
  Records: 'Records', // 我的紀錄：稱號、牌型圖鑑
} as const;
export type TSceneKey = (typeof SceneKey)[keyof typeof SceneKey];
